import PropTypes from 'prop-types';
// @mui
import { styled } from '@mui/material/styles';
import {
  Card,
  Typography,
  CardHeader,
  Box,
  List,
  ListItem,
  ListItemText,
  Divider
} from '@mui/material';
import Iconify from '../../../components/Iconify';

const IconStyle = styled(Iconify)(({ theme }) => ({
  width: 20,
  height: 20,
  marginTop: 1,
  flexShrink: 0,
  marginRight: theme.spacing(2),
}));

ProfileGeneral.propTypes = {
  devices: PropTypes.array.isRequired,
  settlementBanks: PropTypes.array.isRequired,
};

export default function ProfileGeneral({ devices, settlementBanks }) {
  return (
    <Card>
      <CardHeader title="User devices" sx={{ pb: 0 }} />
      <Box sx={{ px: 3, pb: 1 }}>
        <Box
          sx={{
            maxHeight: 220,
            overflowY: 'auto',
            pr: 1,
            border: (theme) => `1px solid ${theme.palette.divider}`,
            borderRadius: 2,
            bgcolor: 'background.neutral',
          }}
        >
          <List dense>
            {(devices.length > 0)
              ? devices.map((e, i) => (
                  <Box key={e.device_id || i}>
                    <ListItem>
                      <ListItemText
                        primary={e.device_id}
                        secondary={`${e.platform} - ${e.name}`}
                      />
                    </ListItem>
                    {i + 1 < devices.length && <Divider component="li" />}
                  </Box>
                ))
              : (
                <ListItem>
                  <ListItemText
                    primary={
                      <Typography variant="caption" color="text.secondary">
                        No devices found
                      </Typography>
                    }
                  />
                </ListItem>
              )}
          </List>
        </Box>
      </Box>

      <Divider sx={{ my: 1 }} />

      <CardHeader title="Bank accounts" sx={{ pb: 0 }} />
      <Box sx={{ px: 3, pb: 2 }}>
        <Box
          sx={{
            maxHeight: 220,
            overflowY: 'auto',
            pr: 1,
            border: (theme) => `1px solid ${theme.palette.divider}`,
            borderRadius: 2,
            bgcolor: 'background.neutral',
          }}
        >
          <List dense>
            {(settlementBanks.length > 0)
              ? settlementBanks.map((e, i) => (
                  <Box key={e.id || i}>
                    <ListItem>
                      <ListItemText
                        primary={e.bank_name}
                        secondary={`ID: ${e.id} - ${e.account_number} - ${e.account_name}`}
                      />
                    </ListItem>
                    {i + 1 < settlementBanks.length && <Divider component="li" />}
                  </Box>
                ))
              : (
                <ListItem>
                  <ListItemText
                    primary={
                      <Typography variant="caption" color="text.secondary">
                        No records found
                      </Typography>
                    }
                  />
                </ListItem>
              )}
          </List>
        </Box>
      </Box>
    </Card>
  );
}
